import { Navigate, Outlet } from "react-router-dom"

const PrivateRoute = () => {
    const token = localStorage.getItem('site')

    if (!token) return <Navigate to="/login"/>
    return <Outlet />
}

export default PrivateRoute

